import { toLocalJson } from './levelSchema';

export function hasStartingMatch(level) {
  const color = (r,c) => {
    if (r >= level.height || c >= level.width || level.blockersLayer[r][c]) return 0;
    const v = level.candiesLayer[r][c];
    return v >= 1 && v <= 5 ? v : v >= 6 && v !== 9 ? level.boosterColorsLayer[r][c] : 0;
  };
  for (let r=0;r<level.height;r++) for (let c=0;c<level.width;c++) {
    const v=color(r,c);
    if (v && ((v===color(r,c+1) && v===color(r,c+2)) ||
      (v===color(r+1,c) && v===color(r+2,c)) ||
      (v===color(r+1,c) && v===color(r,c+1) && v===color(r+1,c+1)))) return true;
  }
  return false;
}

function buildManifest(levels) {
  return {
    schemaVersion: 1,
    levels: levels
      .slice()
      .sort((a, b) => a.levelId - b.levelId)
      .map((l) => ({
        id: l.levelId,
        assetPath: `assets/levels/level_${l.levelId}.json`,
        chapter: l.chapter,
        ...(hasStartingMatch(l) ? { normalizeOnLoad: true } : {}),
      })),
  };
}

export const canExportToDisk = () => typeof window.showDirectoryPicker === 'function';

/**
 * Chrome/Edge only: lets the admin pick the jelly_match/assets/levels folder
 * directly and writes level_<id>.json + manifest.json into it via the File
 * System Access API — no intermediate download/copy step.
 */
export async function exportLevelsToDisk(levels) {
  const dirHandle = await window.showDirectoryPicker({ id: 'jelly-match-levels', mode: 'readwrite' });
  for (const level of levels) {
    const fileHandle = await dirHandle.getFileHandle(`level_${level.levelId}.json`, { create: true });
    const writable = await fileHandle.createWritable();
    await writable.write(JSON.stringify(toLocalJson(level), null, 2) + '\n');
    await writable.close();
  }
  const manifestHandle = await dirHandle.getFileHandle('manifest.json', { create: true });
  const writable = await manifestHandle.createWritable();
  await writable.write(JSON.stringify(buildManifest(levels), null, 2) + '\n');
  await writable.close();
}

/** Fallback for browsers without the File System Access API (Firefox/Safari). */
export function downloadLevelsBundle(levels) {
  const bundle = {
    manifest: buildManifest(levels),
    levels: Object.fromEntries(levels.map((l) => [l.levelId, toLocalJson(l)])),
  };
  const blob = new Blob([JSON.stringify(bundle, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'jelly-match-levels-export.json';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
